require('./tppKeyConsentHistoryTableRow.scss');
// @ vendors
const React = require('react');

// @ commons
import { OKTableRow } from 'commonsComponents/OKTableRow';
import { OKTableCell } from 'commonsComponents/OKTableCell';

export default function TppKeyConsentHistoryTableRow(props) {
    const { activationDate, consentRecurringIndicator, consentStatus } = props;

    return (
        <tbody>
            <OKTableRow>
                <OKTableCell className="tpp-key-consent-history-table-row__activation-date-column">
                    {activationDate}
                </OKTableCell>

                <OKTableCell className="tpp-key-consent-history-table-row__recurring-indicator-column">
                    {consentRecurringIndicator}
                </OKTableCell>

                <OKTableCell className="tpp-key-consent-history-table-row__status-column">
                    {consentStatus}
                </OKTableCell>
            </OKTableRow>
        </tbody>
    );
}

